module.exports = __webpack_public_path__ + "static/media/kit_weatherStation_bg.9f2429f4.png";